"use strict";

import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";

import { storage } from "../../config/firebase";
import { reloadVideoObjectName } from "./reloadVideo.js";

// Uploads a video file to Storage and resolves with its download URL, which is
// the form the ingestion task reads (as in project creation).
export const uploadProjectVideo = ({ file, projectName, onProgress }) =>
    new Promise((resolve, reject) => {
        const task = uploadBytesResumable(
            ref(storage, reloadVideoObjectName(projectName, file.name)),
            file
        );

        task.on(
            "state_changed",
            (snapshot) =>
                onProgress?.((snapshot.bytesTransferred / snapshot.totalBytes) * 100),
            reject,
            () => getDownloadURL(task.snapshot.ref).then(resolve, reject)
        );
    });
